export function uploadFile(e, uploadedName, countUploadedName, switchUploadFiles, currentStep = 1,  ) {
        let countNames;
          uploadedName.value.push(e.target.name)
          countUploadedName.value = count(uploadedName.value);
          countNames = countUploadedName.value[`${e.target.name}`]

          const input = document.querySelector(`[name="${e.target.name}"]`) as HTMLInputElement || null;
          if (input?.files) {
            switchUploadFiles = (typeof switchUploadFiles === 'undefined') ? '' : switchUploadFiles(e, input)
            if (input?.files?.length > 0) {
              let inputName;

              if (input?.files[0]?.name.length > 46) {
                inputName = input?.files[0]?.name.slice(0, 20) + '...' + input?.files[0]?.name.slice(-20);
              } else {
                inputName = input?.files[0]?.name
              }
              showUploadLabel(input, e.target.name, inputName, uploadedName, undefined, countNames);
            }
          }
  }

  const count = (array) => {
    return array.reduce(function (stack, value) {
      return stack[value] ? stack[value]++ : stack[value] = 1, stack;
    }, {});
  }

  export function showUploadLabel(input, inputName, fileName, uploadedName, uploadedNameFellowship, countNames = 0) {
    const customUpload = input?.closest('.custom-upload');
    const fileLabelWrapper = customUpload?.querySelector('.grant-and-diploma-custom-file-list');
    let titleLabel = document.createElement('span');
    titleLabel.className = "grant-and-diploma-custom-file-list d-flex align-items-center";
    titleLabel.onclick = () => fileClear(inputName, uploadedName, uploadedNameFellowship);
    titleLabel.innerHTML = `<span class="grant-and-diploma-custom-file-list-inner d-flex align-items-center"><span>${fileName}</span><span class="grant-and-diploma-custom-file-list-inner-clear"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" width="16" height="16" aria-label="Close-form icon" class="icon icon-close-form">
          <path d="M3.78,3.09l.07,.06L8,7.29,12.15,3.15l.07-.06c.19-.13,.46-.12,.64,.06,.2,.2,.2,.51,0,.71l-4.15,4.15,4.15,4.15c.2,.2,.2,.51,0,.71-.17,.17-.44,.19-.64,.06l-.07-.06-4.15-4.15L3.85,12.85l-.07,.06c-.19,.13-.46,.12-.64-.06-.2-.2-.2-.51,0-.71l4.15-4.15L3.15,3.85c-.2-.2-.2-.51,0-.71,.17-.17,.44-.19,.64-.06Z"/>
      </svg></span></span>`;
    fileLabelWrapper?.replaceWith(titleLabel)
    if (countNames > 1) {
      const errorLabelUploadedMore = customUpload?.querySelector('.grant-and-diploma-custom-file-upload-error-message--uploaded-more');
      if (errorLabelUploadedMore) {
        errorLabelUploadedMore.remove()
      }

      let uploadedMoreThanLimit = document.createElement('span');
      uploadedMoreThanLimit.className = "invalid-feedback grant-and-diploma-custom-file-upload-error-message--uploaded-more";
      uploadedMoreThanLimit.innerHTML = 'Only 1 file can be uploaded';
      titleLabel.after(uploadedMoreThanLimit)
    }

    const errorLabel = customUpload?.querySelector('.grant-and-diploma-custom-file-upload-error-message--no-upload');
    if (errorLabel) {
      errorLabel.remove()
    }

    // uploadedError.value = false;
  }

  export function showUploadedFilesNames(name, file, uploadedName, uploadedNameFellowship){
    if (name) {
      const input = document.querySelector(`[name="${name}"]`);
      if (file) {
        let inputName;

        if (file?.name.length > 46) {
          inputName = file?.name.slice(0, 20) + '...' + file?.name.slice(-20);
        } else {
          inputName = file?.name
        }

        showUploadLabel(input, name, inputName, uploadedName, uploadedNameFellowship);
      }
    }
}

  const fileClear = (name, uploadedName, uploadedNameFellowship) => {
    const input = document.querySelector(`[name="${name}"]`) as HTMLInputElement || null;
    const inputWrapper = input?.closest('.custom-upload');
    const uploadedLabel = inputWrapper?.querySelector('.grant-and-diploma-custom-file-list-inner');
    const errorMessage = inputWrapper?.querySelector('.grant-and-diploma-custom-file-upload-error-message--uploaded-more');

    uploadedLabel?.remove();

    if (errorMessage) {
      errorMessage.remove();
    }
    if (input) {
      input.value = '';
    }

    const newUploadedId = uploadedName.value.filter(item => item !== name);
    uploadedName.value = newUploadedId;
    if (typeof uploadedNameFellowship !== 'undefined') {
      const newFellowshipUploadedId = uploadedNameFellowship!.value.filter(item => item !== name);
      uploadedNameFellowship!.value = newFellowshipUploadedId;
    }
  }

  export function prevStepShowUploadedFilesNames(documentsNamesArray, savedValues, uploadedName, uploadedNameFellowship) {
        documentsNamesArray.forEach((doc: any) => {
          for (const keyDoc in doc) {
            for (const keyValue in savedValues.value) {
              if (keyValue == doc[keyDoc]) {
                showUploadedFilesNames(keyValue, savedValues.value[keyValue], uploadedName, uploadedNameFellowship);
              }
            }
          }
        })
  }


  export function uploadFileFellowship(e, uploadedName, countUploadedName, switchUploadFiles, currentStep, uploadedNameFellowship, countUploadedNameFellowship ) {
    let countNames;
    if(currentStep.value === 2) {
      uploadedNameFellowship.value.push(e.target.name)
      countUploadedNameFellowship.value = count(uploadedNameFellowship.value);
      countNames = countUploadedNameFellowship.value[`${e.target.name}`]
      } else {
      uploadedName.value.push(e.target.name)
      countUploadedName.value = count(uploadedName.value);
      countNames = countUploadedName.value[`${e.target.name}`]
      }

      const input = document.querySelector(`[name="${e.target.name}"]`) as HTMLInputElement || null;
      if (input?.files) {
        switchUploadFiles = (typeof switchUploadFiles === 'undefined') ? '' : switchUploadFiles(e, input)
        if (input?.files?.length > 0) {
          let inputName;

          if (input?.files[0]?.name.length > 46) {
            inputName = input?.files[0]?.name.slice(0, 20) + '...' + input?.files[0]?.name.slice(-20);
          } else {
            inputName = input?.files[0]?.name
          }
          showUploadLabel(input, e.target.name, inputName, uploadedName, uploadedNameFellowship, countNames);
        }
      }
}
